function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.00003 14.72C4.28868 14.72 1.28003 11.7114 1.28003 8C1.28003 4.28864 4.28868 1.28 8.00003 1.28C11.7114 1.28 14.72 4.28864 14.72 8C14.72 11.7114 11.7114 14.72 8.00003 14.72ZM3.99 7.26001C3.58131 7.26001 3.25 7.59132 3.25 8.00001C3.25 8.4087 3.58131 8.74001 3.99 8.74001H12.01C12.4187 8.74001 12.75 8.4087 12.75 8.00001C12.75 7.59132 12.4187 7.26001 12.01 7.26001L3.99 7.26001Z",
  fill: "currentColor"
});

const SvgDisconnected = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisconnected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disconnected.7a54266b.svg";
export { ForwardRef as ReactComponent };